import {
  Text,
  TextAlignment,
  TokenTextAppearance,
  styled,
} from '@volkswagen-onehub/components-core';
import { useTranslation } from 'react-i18next';
import { minimalScreenWidth } from '@/common/breakpoints';
import { GiveawayResponse } from '@org-avp/avp-hck-dga-customerui-commons';
import { useContext } from 'react';
import { GiveawayContext } from '@/state/state';

const StyledContainer = styled.h1`
  display: flex;
  justify-content: center;
  text-align: center;
  padding-left: ${(props) => props.theme.size.dynamic0150};
  padding-right: ${(props) => props.theme.size.dynamic0150};
  padding-top: ${(props) => props.theme.size.static250};
  padding-bottom: ${(props) => props.theme.size.static200};

  @media screen and ${minimalScreenWidth.l} {
    justify-content: left;
    padding-left: ${(props) => props.theme.size.dynamic0250};
    padding-right: ${(props) => props.theme.size.dynamic0250};
    padding-top: ${(props) => props.theme.size.static550};
    padding-bottom: ${(props) => props.theme.size.static510};
  }

  @media screen and ${minimalScreenWidth.xl} {
    padding-left: ${(props) => props.theme.size.dynamic0450};
    padding-right: ${(props) => props.theme.size.dynamic0450};
  }
`;

export const Welcome = (): React.JSX.Element => {
  const { t } = useTranslation();
  const { isCertifiedPreOwned }: GiveawayResponse = useContext(GiveawayContext);

  return (
    <StyledContainer data-testid="welcome-container">
      <Text bold textAlign={TextAlignment.center} appearance={TokenTextAppearance.headline400}>
        {isCertifiedPreOwned ? t(`header.cpoGreetings`) : t(`header.greetings`)}
      </Text>
    </StyledContainer>
  );
};
